import { BillingInterval } from "./StripeProduct"

export enum SubscriptionPlan {
  FREE = "Free",
  PERSONAL = "Personal",
  PRO = "Pro",
  BUSINESS = "Business",
  ENTERPRISE = "Enterprise",
}

export enum SubscriptionState {
  ACTIVE = "active",
  CANCELED = "canceled",
  INCOMPLETE = "incomplete",
  INCOMPLETE_EXPIRED = "incomplete_expired",
  PAST_DUE = "past_due",
  UNPAID = "unpaid",
  PAUSED = "paused",
  EXPIRED = "expired",
  TRIALING = "trialing",
}

export interface SubscriptionParams {
  plan: string
  interval: BillingInterval
  returnUrl?: string
}

export interface SubscriptionUrlParams {
  plan: string | null
  interval: string | null
  returnUrl: string | null
}
